// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Toast — notifications empilables, ancrees en bas a droite.
   Moderne : carte arrondie, ombre douce, accent + icone par etat,
   slide-in, barre de progression (pause au survol).
   ========================================================================== */

.toast-viewport {
  position: fixed;
  z-index: 10000;
  display: flex;
  flex-direction: column-reverse; /* plus recent en haut de la pile */
  gap: 12px;
  width: auto; /* s'ajuste au toast le plus large */
  max-width: calc(100vw - 32px);
  pointer-events: none; /* laisse passer les clics ; chaque toast les recapte */
}

/* Ancrages composables : top/bottom x left/right/center. Les variables --toast-enter-*
   dictent le sens du slide (heritees par les toasts, lues dans les keyframes). */
.toast-viewport--top { top: 24px; }
.toast-viewport--bottom { bottom: 24px; }
.toast-viewport--right {
  right: 24px;
  align-items: flex-end;
  --toast-enter-x: calc(100% + 32px); /* entre depuis la droite */
  --toast-enter-y: 0px;
}
.toast-viewport--left {
  left: 24px;
  align-items: flex-start;
  --toast-enter-x: calc(-100% - 32px); /* entre depuis la gauche */
  --toast-enter-y: 0px;
}
.toast-viewport--center {
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
  --toast-enter-x: 0px;
}
.toast-viewport--top.toast-viewport--center { --toast-enter-y: -24px; }   /* entre par le haut */
.toast-viewport--bottom.toast-viewport--center { --toast-enter-y: 24px; } /* entre par le bas */

.toast {
  --toast-accent: #2563eb;
  --toast-icon-bg: #eff6ff;
  --toast-bg: #ffffff;
  pointer-events: auto;
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 13px;
  width: 400px; /* etroit par defaut (autosave) */
  max-width: calc(100vw - 32px);
  padding: 16px 17px;
  background: var(--toast-bg);
  border: 1px solid rgba(15, 23, 42, 0.10);
  border-radius: 14px;
  box-shadow:
    0 16px 44px -8px rgba(15, 23, 42, 0.34),
    0 6px 16px -4px rgba(15, 23, 42, 0.20);
  overflow: hidden;
  animation: toast-in 0.30s cubic-bezier(0.21, 1.02, 0.73, 1) both;
}

/* Toast a actions (ex : profil incomplet, 2 boutons) : plus large pour tenir sur une ligne. */
.toast--wide {
  width: 460px;
}

.toast--exit {
  animation: toast-out 0.24s cubic-bezier(0.4, 0, 1, 1) forwards;
}

/* --- Etats --- (fond legerement teinte pour la visibilite, sans bordure coloree) */
.toast--success {
  --toast-accent: #16a34a;
  --toast-icon-bg: #dcfce7;
  --toast-bg: #f0fdf4;
}
.toast--error {
  --toast-accent: #dc2626;
  --toast-icon-bg: #fee2e2;
  --toast-bg: #fef2f2;
}
.toast--warning {
  --toast-accent: #f59e0b;
  --toast-icon-bg: #fef3c7;
  --toast-bg: #fffbeb;
}
.toast--info {
  --toast-accent: #2563eb;
  --toast-icon-bg: #dbeafe;
  --toast-bg: #eff6ff;
}
/* En cours d'enregistrement (spinner) : gris neutre — operation en cours, pas un etat final.
   Declare APRES .toast--info pour l'emporter (le toast saving est de type info). */
.toast--loading {
  --toast-accent: #64748b; /* slate-500 */
  --toast-icon-bg: #f1f5f9; /* slate-100 */
  --toast-bg: #f8fafc; /* slate-50 */
}

/* --- Icone --- */
.toast__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--toast-icon-bg);
  color: var(--toast-accent);
  margin-top: 1px;
}
.toast__icon svg {
  width: 21px;
  height: 21px;
}

/* Spinner (etat loading, ex : enregistrement en cours) */
.toast__spinner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2.5px solid rgba(15, 23, 42, 0.12);
  border-top-color: var(--toast-accent);
  animation: toast-spin 0.7s linear infinite;
}

@keyframes toast-spin {
  to {
    transform: rotate(360deg);
  }
}

/* --- Corps --- */
.toast__body {
  flex: 1 1 auto;
  min-width: 0;
}
.toast__title {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  color: #0f172a;
  margin-bottom: 3px;
}
.toast__message {
  font-size: 14px;
  line-height: 1.45;
  color: #475569;
  word-wrap: break-word;
}

/* --- Actions --- */
.toast__actions {
  display: flex;
  flex-wrap: wrap; /* tiennent sur une ligne a la largeur actuelle ; repli propre si trop long */
  gap: 8px;
  margin-top: 12px;
}
.toast__btn {
  flex: 0 0 auto;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  padding: 8px 13px;
  border-radius: 9px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.toast__btn--primary {
  background: #f97316;
  color: #ffffff;
}
.toast__btn--primary:hover {
  background: #ea6a0c;
}
.toast__btn--secondary {
  background: transparent;
  color: #6b7280;
  border-color: #e5e7eb;
}
.toast__btn--secondary:hover {
  background: #f9fafb;
  color: #374151;
}

/* --- Fermer --- */
.toast__close {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-top: 1px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.toast__close:hover {
  background: rgba(15, 23, 42, 0.06);
  color: #4b5563;
}
.toast__close svg {
  width: 15px;
  height: 15px;
}

/* --- Barre de progression --- */
.toast__progress {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 100%;
  background: var(--toast-accent);
  opacity: 0.45;
  transform-origin: left center;
  animation-name: toast-progress;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

/* Entree : glisse depuis la direction dictee par la position (variables posees sur le viewport). */
@keyframes toast-in {
  from {
    opacity: 0;
    transform: translate(var(--toast-enter-x, 0px), var(--toast-enter-y, 0px));
  }
  to {
    opacity: 1;
    transform: translate(0px, 0px);
  }
}

/* Sortie : repart dans la meme direction + collapse pour refermer la pile. */
@keyframes toast-out {
  from {
    opacity: 1;
    transform: translate(0px, 0px);
    max-height: 200px;
    margin-bottom: 0;
  }
  to {
    opacity: 0;
    transform: translate(var(--toast-enter-x, 0px), var(--toast-enter-y, 0px));
    max-height: 0;
    margin-bottom: -12px; /* compense le gap pendant le collapse */
    padding-top: 0;
    padding-bottom: 0;
  }
}

@keyframes toast-progress {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}

@media (max-width: 480px) {
  .toast-viewport--top { top: 12px; }
  .toast-viewport--bottom { bottom: 12px; }
  .toast-viewport--right { right: 12px; }
  .toast-viewport--left { left: 12px; }
  /* la largeur du toast est deja plafonnee par max-width: calc(100vw - 32px) */
}

@media (prefers-reduced-motion: reduce) {
  .toast,
  .toast--exit,
  .toast__progress {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/Toast/Toast.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,8BAA8B,EAAE,mCAAmC;EACnE,SAAS;EACT,WAAW,EAAE,oCAAoC;EACjD,6BAA6B;EAC7B,oBAAoB,EAAE,uDAAuD;AAC/E;;AAEA;iFACiF;AACjF,uBAAuB,SAAS,EAAE;AAClC,0BAA0B,YAAY,EAAE;AACxC;EACE,WAAW;EACX,qBAAqB;EACrB,kCAAkC,EAAE,2BAA2B;EAC/D,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,mCAAmC,EAAE,2BAA2B;EAChE,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;AACtB;AACA,8CAA8C,sBAAsB,EAAE,IAAI,sBAAsB;AAChG,iDAAiD,qBAAqB,EAAE,EAAE,qBAAqB;;AAE/F;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY,EAAE,iCAAiC;EAC/C,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC;EACxC,mBAAmB;EACnB;;0CAEwC;EACxC,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA,8FAA8F;AAC9F;EACE,YAAY;AACd;;AAEA;EACE,8DAA8D;AAChE;;AAEA,oFAAoF;AACpF;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;mFACmF;AACnF;EACE,uBAAuB,EAAE,cAAc;EACvC,wBAAwB,EAAE,cAAc;EACxC,mBAAmB,EAAE,aAAa;AACpC;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe,EAAE,6EAA6E;EAC9F,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA,mGAAmG;AACnG;EACE;IACE,UAAU;IACV,0EAA0E;EAC5E;EACA;IACE,UAAU;IACV,8BAA8B;EAChC;AACF;;AAEA,6EAA6E;AAC7E;EACE;IACE,UAAU;IACV,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,0EAA0E;IAC1E,aAAa;IACb,oBAAoB,EAAE,wCAAwC;IAC9D,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,uBAAuB,SAAS,EAAE;EAClC,0BAA0B,YAAY,EAAE;EACxC,yBAAyB,WAAW,EAAE;EACtC,wBAAwB,UAAU,EAAE;EACpC,6EAA6E;AAC/E;;AAEA;EACE;;;IAGE,eAAe;EACjB;AACF","sourcesContent":["/* ==========================================================================\n   Toast — notifications empilables, ancrees en bas a droite.\n   Moderne : carte arrondie, ombre douce, accent + icone par etat,\n   slide-in, barre de progression (pause au survol).\n   ========================================================================== */\n\n.toast-viewport {\n  position: fixed;\n  z-index: 10000;\n  display: flex;\n  flex-direction: column-reverse; /* plus recent en haut de la pile */\n  gap: 12px;\n  width: auto; /* s'ajuste au toast le plus large */\n  max-width: calc(100vw - 32px);\n  pointer-events: none; /* laisse passer les clics ; chaque toast les recapte */\n}\n\n/* Ancrages composables : top/bottom x left/right/center. Les variables --toast-enter-*\n   dictent le sens du slide (heritees par les toasts, lues dans les keyframes). */\n.toast-viewport--top { top: 24px; }\n.toast-viewport--bottom { bottom: 24px; }\n.toast-viewport--right {\n  right: 24px;\n  align-items: flex-end;\n  --toast-enter-x: calc(100% + 32px); /* entre depuis la droite */\n  --toast-enter-y: 0px;\n}\n.toast-viewport--left {\n  left: 24px;\n  align-items: flex-start;\n  --toast-enter-x: calc(-100% - 32px); /* entre depuis la gauche */\n  --toast-enter-y: 0px;\n}\n.toast-viewport--center {\n  left: 50%;\n  transform: translateX(-50%);\n  align-items: center;\n  --toast-enter-x: 0px;\n}\n.toast-viewport--top.toast-viewport--center { --toast-enter-y: -24px; }   /* entre par le haut */\n.toast-viewport--bottom.toast-viewport--center { --toast-enter-y: 24px; } /* entre par le bas */\n\n.toast {\n  --toast-accent: #2563eb;\n  --toast-icon-bg: #eff6ff;\n  --toast-bg: #ffffff;\n  pointer-events: auto;\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 13px;\n  width: 400px; /* etroit par defaut (autosave) */\n  max-width: calc(100vw - 32px);\n  padding: 16px 17px;\n  background: var(--toast-bg);\n  border: 1px solid rgba(15, 23, 42, 0.10);\n  border-radius: 14px;\n  box-shadow:\n    0 16px 44px -8px rgba(15, 23, 42, 0.34),\n    0 6px 16px -4px rgba(15, 23, 42, 0.20);\n  overflow: hidden;\n  animation: toast-in 0.30s cubic-bezier(0.21, 1.02, 0.73, 1) both;\n}\n\n/* Toast a actions (ex : profil incomplet, 2 boutons) : plus large pour tenir sur une ligne. */\n.toast--wide {\n  width: 460px;\n}\n\n.toast--exit {\n  animation: toast-out 0.24s cubic-bezier(0.4, 0, 1, 1) forwards;\n}\n\n/* --- Etats --- (fond legerement teinte pour la visibilite, sans bordure coloree) */\n.toast--success {\n  --toast-accent: #16a34a;\n  --toast-icon-bg: #dcfce7;\n  --toast-bg: #f0fdf4;\n}\n.toast--error {\n  --toast-accent: #dc2626;\n  --toast-icon-bg: #fee2e2;\n  --toast-bg: #fef2f2;\n}\n.toast--warning {\n  --toast-accent: #f59e0b;\n  --toast-icon-bg: #fef3c7;\n  --toast-bg: #fffbeb;\n}\n.toast--info {\n  --toast-accent: #2563eb;\n  --toast-icon-bg: #dbeafe;\n  --toast-bg: #eff6ff;\n}\n/* En cours d'enregistrement (spinner) : gris neutre — operation en cours, pas un etat final.\n   Declare APRES .toast--info pour l'emporter (le toast saving est de type info). */\n.toast--loading {\n  --toast-accent: #64748b; /* slate-500 */\n  --toast-icon-bg: #f1f5f9; /* slate-100 */\n  --toast-bg: #f8fafc; /* slate-50 */\n}\n\n/* --- Icone --- */\n.toast__icon {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: var(--toast-icon-bg);\n  color: var(--toast-accent);\n  margin-top: 1px;\n}\n.toast__icon svg {\n  width: 21px;\n  height: 21px;\n}\n\n/* Spinner (etat loading, ex : enregistrement en cours) */\n.toast__spinner {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2.5px solid rgba(15, 23, 42, 0.12);\n  border-top-color: var(--toast-accent);\n  animation: toast-spin 0.7s linear infinite;\n}\n\n@keyframes toast-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* --- Corps --- */\n.toast__body {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n.toast__title {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.35;\n  color: #0f172a;\n  margin-bottom: 3px;\n}\n.toast__message {\n  font-size: 14px;\n  line-height: 1.45;\n  color: #475569;\n  word-wrap: break-word;\n}\n\n/* --- Actions --- */\n.toast__actions {\n  display: flex;\n  flex-wrap: wrap; /* tiennent sur une ligne a la largeur actuelle ; repli propre si trop long */\n  gap: 8px;\n  margin-top: 12px;\n}\n.toast__btn {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  padding: 8px 13px;\n  border-radius: 9px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n.toast__btn--primary {\n  background: #f97316;\n  color: #ffffff;\n}\n.toast__btn--primary:hover {\n  background: #ea6a0c;\n}\n.toast__btn--secondary {\n  background: transparent;\n  color: #6b7280;\n  border-color: #e5e7eb;\n}\n.toast__btn--secondary:hover {\n  background: #f9fafb;\n  color: #374151;\n}\n\n/* --- Fermer --- */\n.toast__close {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  margin-top: 1px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.toast__close:hover {\n  background: rgba(15, 23, 42, 0.06);\n  color: #4b5563;\n}\n.toast__close svg {\n  width: 15px;\n  height: 15px;\n}\n\n/* --- Barre de progression --- */\n.toast__progress {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 3px;\n  width: 100%;\n  background: var(--toast-accent);\n  opacity: 0.45;\n  transform-origin: left center;\n  animation-name: toast-progress;\n  animation-timing-function: linear;\n  animation-fill-mode: forwards;\n}\n\n/* Entree : glisse depuis la direction dictee par la position (variables posees sur le viewport). */\n@keyframes toast-in {\n  from {\n    opacity: 0;\n    transform: translate(var(--toast-enter-x, 0px), var(--toast-enter-y, 0px));\n  }\n  to {\n    opacity: 1;\n    transform: translate(0px, 0px);\n  }\n}\n\n/* Sortie : repart dans la meme direction + collapse pour refermer la pile. */\n@keyframes toast-out {\n  from {\n    opacity: 1;\n    transform: translate(0px, 0px);\n    max-height: 200px;\n    margin-bottom: 0;\n  }\n  to {\n    opacity: 0;\n    transform: translate(var(--toast-enter-x, 0px), var(--toast-enter-y, 0px));\n    max-height: 0;\n    margin-bottom: -12px; /* compense le gap pendant le collapse */\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n}\n\n@keyframes toast-progress {\n  from {\n    transform: scaleX(1);\n  }\n  to {\n    transform: scaleX(0);\n  }\n}\n\n@media (max-width: 480px) {\n  .toast-viewport--top { top: 12px; }\n  .toast-viewport--bottom { bottom: 12px; }\n  .toast-viewport--right { right: 12px; }\n  .toast-viewport--left { left: 12px; }\n  /* la largeur du toast est deja plafonnee par max-width: calc(100vw - 32px) */\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .toast,\n  .toast--exit,\n  .toast__progress {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
